import type { Edge, Node } from '@xyflow/react';
import type { WidgetNodeData } from './types';
import type { StartConfig } from '@legacy-shared/widgets/core/start';
import {
  isOfficeClosedConfigured as officeClosedConfigured,
  isZeroPressedConfigured,
  resolveStartOutput,
  startActionOutputs,
} from '@legacy-shared/flow/start-output';

const startRoutingHandles: string[] = Object.values(startActionOutputs);

function startRouteConfig(startNode: Node<WidgetNodeData> | undefined) {
  return startNode?.data.config as StartConfig | undefined;
}

function isStartRoutingOutput(startNode: Node<WidgetNodeData> | undefined, nodeId: string, handleId: string) {
  return nodeId === startNode?.id && startRoutingHandles.includes(handleId);
}

export function isZeroRouteConfigured(startNode: Node<WidgetNodeData> | undefined) {
  return isZeroPressedConfigured(startRouteConfig(startNode));
}

export function isOfficeClosedConfigured(startNode: Node<WidgetNodeData> | undefined) {
  return officeClosedConfigured(startRouteConfig(startNode));
}

export function isZeroRouteAllowed(startNode: Node<WidgetNodeData> | undefined, nodeId: string, handleId: string) {
  if (!isZeroRouteConfigured(startNode)) return false;
  return !isStartRoutingOutput(startNode, nodeId, handleId);
}

export function isOfficeClosedAllowed(startNode: Node<WidgetNodeData> | undefined, nodeId: string, handleId: string) {
  if (!isOfficeClosedConfigured(startNode)) return false;
  return !isStartRoutingOutput(startNode, nodeId, handleId);
}

function toOutputEdges(edges: Edge[]) {
  return edges.map((e) => ({ source: e.source, target: e.target, sourceHandle: e.sourceHandle ?? undefined }));
}

export function isStartOutputSatisfied(startNode: Node<WidgetNodeData> | undefined, edges: Edge[], handleId: string) {
  return resolveStartOutput(startNode, toOutputEdges(edges), handleId) !== undefined;
}
